module.exports = __webpack_public_path__ + "img/symbol_5.5a703a9c.png";